import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const FullContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  width: 100%;
  padding: 0;
  position: relative;
  margin-bottom: 10px;
  ${props => (props.fullHeight ? "height: 100%;" : null)}
  ${props => (props.fullHeight ? "flex-grow: 1;" : null)}
  ${props => props.compact && "margin-bottom: 0;"}
`

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
  padding: 0 16px 0 16px;
  ${props => (props.fullHeight ? "height: 100%;" : null)}
`

const DesktopContainer = ({ children, fullHeight, compact }) => {
  return (
    <FullContainer fullHeight={fullHeight} compact={compact}>
      <Content fullHeight={fullHeight}>{children}</Content>
    </FullContainer>
  )
}

DesktopContainer.defaultProps = {
  fullHeight: false,
  compact: false,
}

DesktopContainer.propTypes = {
  fullHeight: PropTypes.bool,
  compact: PropTypes.bool,
}

export default DesktopContainer
